import { useQuery } from "@tanstack/react-query";

import { getRanaApiV1 } from "@nens/rana/api-v1";

// Single

const getStaticFileQuery = (filePath?: string) => {
  return getRanaApiV1().getQueryOptions({
    ignoreTenant: true,
    queryKey: ["static-file", filePath],
    queryFn: async () =>
      await getRanaApiV1().StaticFilesApi.publicStaticFile({
        filePath: filePath + "",
      }),
    enabled: !!filePath,
    staleTime: Infinity, // Consider fresh forever, since static files don't change
  });
};

export const useStaticFileQuery = (filePath?: string) => {
  return useQuery(getStaticFileQuery(filePath));
};
